import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import isString from 'lodash-es/isString';
import React from 'react';

import useCollections from '../../hooks/useCollections';

import * as CardComponents from '../cards/collections';
import PresentationList, { PresentationListProps } from './PresentationList';

import styles from '../../styles/lists/collections-list.module.css';

const hooks = {
    default: useCollections,
};

export interface CollectionsListProps extends Omit<
    PresentationListProps<Collection>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    cardComponent?: React.ElementType | null;
    cardType?: string | null;
    className?: string | null;
    cardClassName?: string | null;
}

function CollectionsList({
    hook = 'default',
    cardComponent = null,
    cardType = null,
    className = null,
    cardClassName = null,
    ...props
}: CollectionsListProps) {
    return (
        <PresentationList<Collection>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent || getComponentFromName(CardComponents, cardType, 'vertical')
            }
            className={classNames([styles.container, className])}
            cardClassName={classNames([styles.card, cardClassName])}
        />
    );
}

export default CollectionsList;
